<template>
  <v-row>
    <v-col cols="12">
      <v-container pa-3>
        <v-expansion-panels :value="opened"
                            @input="$emit('opened',$event)">
          <v-expansion-panel v-for="(item, i) in listElements"
                             :key="`item-${i}`">
            <v-expansion-panel-header :hide-actions="true"
                                      v-slot="{ open }">
              <b style="flex: unset">
                {{ i + 1 }}.
                <span v-html="item.title"></span>
              </b>
              <v-icon class="flex-grow-0 flex-shrink-0 ml-5"
                      color="primary">
                {{
                open ? "mdi-minus-circle-outline" : "mdi-plus-circle-outline"
                }}
              </v-icon>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="subtitle-1">
                  <span style="line-height: 150% !important;"
                        v-html="item.text"></span>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <slot />
        </v-expansion-panels>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "vue-ongeo-faq",
  props:
  {
    listElements: { type: Array, default: () => { return [] }, required: true },
    opened: { type: String, default: null }
  }
};
</script>
